import CreditCardRoundedIcon from '@mui/icons-material/CreditCardRounded';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';
import NewspaperRoundedIcon from '@mui/icons-material/NewspaperRounded';
import MoveDownRoundedIcon from '@mui/icons-material/MoveDownRounded';
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded';


let methods = [
  {
    label: "Credit Card",
    value: "credit_card",
    Icon: CreditCardRoundedIcon
  },
  {
    label: "Cash",
    value: "cash",
    Icon: PaymentsRoundedIcon
  },
  {
    label: "Check",
    value: "check",
    Icon: NewspaperRoundedIcon
  },
  {
    label: "Quick Pay",
    value: "quick pay",
    Icon: MoveDownRoundedIcon
  },
  {
    label: "Other",
    value: "other",
    Icon: AttachMoneyRoundedIcon
  }
];

export { methods };